import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Constants } from './constants/constants';
import { SelectClientComponent } from './modules/shared/components/select-client/select-client.component';
import { authGuard } from './services/auth-guard/auth.guard';

const routes: Routes = [
  { path: 'login', loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule) },
  { path: 'diet-plan/:unique_token/:diet_plan_id', loadChildren: () => import('./modules/diet-plan-pdf-report/diet-plan-pdf-report.module').then(m => m.dietPlanPdfReportModule) },
  { path: Constants.CLIENT_ROUTE, component: SelectClientComponent, canActivate: [authGuard] },
  { path: '', loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule), canActivate: [authGuard] },
  { path: '**', redirectTo: Constants.OVERVIEW_ROUTE },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
